import { render, staticRenderFns } from "./Glitch.vue?vue&type=template&id=b8f40d00"
import script from "./Glitch.vue?vue&type=script&lang=js"
export * from "./Glitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports